import { FormattedMessage } from 'react-intl'
import Text from 'components/shared/Text'
import { ReactNode } from 'react'
import { useResolutions } from 'store/resolutions'

interface PromotionCodeProps {
    isCopied: boolean
    children: ReactNode
}

export const PromotionCodeBox = ({
    isCopied,
    children,
}: PromotionCodeProps) => {
    const { isMobile, isTablet } = useResolutions()

    const promoCode = (
        <Text variant="bodySmall" color="grayscale_700">
            <FormattedMessage
                id="promo.black_weekend.promotion_code"
                defaultMessage="Skorzystaj z kodu <span>BLACKWEEKEND</span>"
                description="Keep the html tags in the translation"
                values={{
                    span: (chunks: string[]) => (
                        <>
                            {isMobile && <br />}
                            <Text
                                as="span"
                                variant="bodyExtraSmallStrong"
                                color="grayscale_900"
                            >
                                {chunks}
                            </Text>
                        </>
                    ),
                }}
            />
        </Text>
    )

    const clipboardText = (
        <Text
            variant="body12"
            color="grayscale_700"
            style={{ lineHeight: '20px' }}
        >
            <FormattedMessage
                id="promo.summer_sale.promotion_code_success"
                defaultMessage="Skopiowano pomyślnie!"
                description="Keep the html tags in the translation"
            />
        </Text>
    )

    if (isCopied && isTablet) return clipboardText

    return (
        <>
            {promoCode}
            {children}
            {isCopied && clipboardText}
        </>
    )
}
